import { TEXTS } from 'application/pages/AdsPage/renderer/texts';

import { AdCampaignTypeEnum } from '@entities/media';

import { WEEKDAY_KEYS } from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

export const MIN_VALUE_BY_MODE = 5;
export const MAX_VALUE_BY_MODE = 1440;

export const DAYS_MAP = WEEKDAY_KEYS.reduce<Record<string, number>>((acc, key, index) => {
  acc[key] = index + 1;

  return acc;
}, {});

export const TYPE_TEXTS = {
  [AdCampaignTypeEnum.Interval]: TEXTS.AD_TYPE_INTERVAL_QUESTION,
  [AdCampaignTypeEnum.ExactTime]: TEXTS.AD_TYPE_EXACT_QUESTION,
  [AdCampaignTypeEnum.Period]: TEXTS.AD_TYPE_PERIOD_QUESTION,
  [AdCampaignTypeEnum.Groups]: TEXTS.AD_TYPE_GROUPS_QUESTION,
  [AdCampaignTypeEnum.Instant]: TEXTS.AD_TYPE_INSTANT_QUESTION,
};
